'use strict';

var ES6Promise = require('es6-promise').Promise;
var generate = require('./promish-class');
module.exports = generate(ES6Promise);
//# sourceMappingURL=es6-promish.js.map



//////////////////
// WEBPACK FOOTER
// C:/Users/AINSA WEB/Documents/proyects/ROUTEMEE/routemee-web-application/node_modules/promish/dist/promish-node.js
// module id = ../../../../promish/dist/promish-node.js
// module chunks = vendor